module.exports = __webpack_public_path__ + "static/media/10.2019f79b.gif";